import { TProductListItem } from "@/api/services/admin/product/dtos/get-product-list.dto";
import { SORTING } from "@/constants/sorting";
import { useSorting } from "@/hooks/useSorting";
import { useMemo } from "react";

const getSortValue = (item: TProductListItem, sortKey: string): string => {
  switch (sortKey) {
    case "productName":
      return item.name ?? "";
    case "lastLoginAt":
      return item.productContract?.lastLoginAt ?? "";
    case "createdAt":
      return item.productContract?.createdAt ?? "";
    default:
      return "";
  }
};

export const useSortedProducts = (products: TProductListItem[]): TProductListItem[] => {
  const { sorts } = useSorting();

  return useMemo(() => {
    const [sortKey, sortOrder] = (sorts[0] ?? "").split("|");
    if (!sortKey) return products;

    // Apply direction inside the comparator so empty values stay pinned to the bottom for BOTH
    // directions. A trailing `.reverse()` would flip the empties up to the top on DESC.
    const dir = sortOrder === SORTING.DESC ? -1 : 1;

    return [...products].sort((a, b) => {
      const av = getSortValue(a, sortKey);
      const bv = getSortValue(b, sortKey);
      if (av === bv) return 0;
      if (!av) return 1;
      if (!bv) return -1;
      return av.localeCompare(bv) * dir;
    });
  }, [products, sorts]);
};
